const Token = {
    Company: 'COMPANY',
    FirstName: 'FIRST_NAME',
    LastName: 'LAST_NAME',
    Prefix: 'PREFIX',
    SpouseFirstName: 'SPOUSE_FIRST_NAME',
    SpouseLastName: 'SPOUSE_LAST_NAME',
    SpousePrefix: 'SPOUSE_PREFIX',

    Contact: {
        Email: 'EMAIL',
        EmailLink: 'EMAIL_LINK',
        Message: 'MESSAGE',
        Name: 'NAME',
        Phone: 'PHONE'
    },

    Inventory: {
        Artist: 'ARTIST',
        Date: 'DATE',
        Dimensions: 'DIMENSIONS',
        Edition: 'EDITION',
        Medium: 'MEDIUM',
        Price: 'PRICE',
        Title: 'TITLE'
    },

    Footer: {
        CurrentYear: 'CURRENT_YEAR',
        ListCompany: 'LIST_COMPANY',
        ListAddressHtml: 'LIST_ADDRESS_HTML'
    },

    getTag: (token) => {
        switch (token) {
            case Token.Company:
                return 'Company';
            case Token.FirstName:
                return 'FirstName';
            case Token.LastName:
                return 'LastName';
            case Token.Prefix:
                return 'Prefix';
            case Token.SpouseFirstName:
                return 'SpouseFirstName';
            case Token.SpouseLastName:
                return 'SpouseLastName';
            case Token.SpousePrefix:
                return 'SpousePrefix';
        }
    },

    getDefaultTokenConfig: (display, token) => {
        return {
            display: display,
            format: (data) => { return `{${data.token}${data.default ? `(${data.default})` : ''}}` },
            options: [
                { display: 'Default Value', name: 'default' }
            ],
            token: token
        }
    },

    getWrappedTokenConfig: (display, token, defaultAvailable = true) => {
        const config = {
            display,
            format: (data) => { return `${data.before || ''}{${data.token}${data.default ? `(${data.default})` : ''}}${data.after || ''}` },
            options: [
                { display: 'Prefix Label', name: 'before' },
                { display: 'Suffix Label', name: 'after' }
            ],
            token
        };
        if (defaultAvailable) {
            config.options.push({ display: 'Default Value', name: 'default' });
        }
        return config;
    },

    extractTokenOptions: (tokenizedString, handler) => {
        if (!tokenizedString) {
            return {};
        }
        let parsedResultString = tokenizedString;
        let char, options;
        let indexStart = parsedResultString.indexOf('{');
        let indexEnd = indexStart;
        let keyword = '';
        let parsingList = false;
        let parsingOptions = false;
        let tokens = [];
        let parsingString = false;
        while (indexStart >= 0 && indexEnd < parsedResultString.length - 1) {
            indexEnd += 1;
            char = parsedResultString.charAt(indexEnd);
            switch (char) {
                case '(':
                    if (parsingList || parsingOptions || parsingString) {
                        options += char;
                        break;
                    }
                    // Start options
                    options = '';
                    parsingOptions = true;
                    break;
                case ')':
                    if (parsingList || parsingString) {
                        options += char;
                        break;
                    }
                    // End options
                    parsingOptions = false;
                    break;
                case '[':
                    if (parsingOptions) {
                        parsingList = true;

                        // List components are converted to strings (wrapped in quotes) since they will be parsed separately
                        options += char;
                    }
                    break;
                case '"':
                    if (parsingList || parsingOptions) {
                        options += '"';
                        parsingString = !parsingString;
                    }
                    break;
                case ']':
                    if (parsingOptions) {
                        // List components are converted to strings (wrapped in quotes) since they will be parsed separately
                        options += char;
                    }
                    parsingList = false;
                    break;
                case '}':
                    if (parsingOptions) {
                        options += char;
                        break;
                    }
                    // End keyword
                    let parsedProps;
                    if (options) {
                        try { parsedProps = JSON.parse(`{${options}}`); } catch (e) { }
                    }
                    if (parsedProps) {
                        parsedProps.tag = Token.getTag(keyword);
                    }
                    let replaceString;
                    switch (keyword) {
                        case 'ALTERNATE_PRICES':
                        case 'GROUP':
                            if (!parsedProps) {
                                break;
                            }
                            let parsedComponents = [];
                            if (parsedProps.components && parsedProps.components.length > 0) {
                                // Get replacement strings for each component in the group
                                parsedProps.components.forEach((d) => {
                                    if (!d) {
                                        return;
                                    }
                                    const string = d.replaceAll('"', '\\\"').replaceAll("*'", '"').trim();
                                    const tokenOptions = Token.extractTokenOptions(string, handler);
                                    if (tokenOptions.parsedResultString === "") {
                                        return;
                                    }
                                    if (tokenOptions.parsedResultString != undefined) {
                                        parsedComponents.push(tokenOptions.parsedResultString);
                                        tokens.push(...tokenOptions.tokens);
                                    } else {
                                        parsedComponents.push(d);
                                    }
                                })
                            }
                            replaceString = parsedComponents.join(parsedProps.separator ? parsedProps.separator : '');
                            break;
                        default:
                            if (handler && parsedProps) {
                                // Get the replacement string for the token keyword and props
                                replaceString = handler(keyword, parsedProps);
                                parsedProps.replaceString = replaceString;
                                tokens.push(parsedProps);
                            }
                    }
                    if (replaceString != undefined) {
                        // Replace the token with the replacement string
                        parsedResultString = parsedResultString.substring(0, indexStart) + replaceString + parsedResultString.substring(indexEnd + 1);

                        // Update end index to point to the end of the replacement string so parts of the string aren't skipped or processed twice
                        indexEnd = indexStart + replaceString.length;
                    }
                    keyword = '';
                    options = undefined;

                    // Find start of next keyword (if present)
                    indexStart = parsedResultString.indexOf('{', indexEnd);
                    indexEnd = indexStart;
                    break;
                default:
                    if (parsingOptions) {
                        options += char;
                    } else {
                        keyword += char;
                    }
                    break;
            }
        }
        return { tokens, parsedResultString };
    }
}
export default Token;